import React, { useRef, useEffect } from "react";
import Chart from "chart.js/auto";

const ChartComponent = ({
  type,
  data,
  options,
  width = "100%",
  height = "300px",
}) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    const chartCanvas = chartRef.current.getContext("2d");

    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    chartInstance.current = new Chart(chartCanvas, {
      type,
      data,
      options: {
        maintainAspectRatio: false,
        ...options,
      },
    });

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [type, data, options]);

  return <canvas ref={chartRef} width={width} height={height} />;
};

export default ChartComponent;
